import type { ReactNode } from 'react';

export const detailLabelClass = 'mb-1 text-xs font-semibold text-label';
export const detailValueClass = 'break-words text-sm text-body';

export default function DetailFields({ fields }: { fields: [string, ReactNode][] }) {
  return <dl className="grid gap-x-5 gap-y-3" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(min(100%, 220px), 1fr))' }}>
    {fields.map(([label, value]) => <div key={label} className="min-w-0">
      <dt className={detailLabelClass}>{label}</dt>
      <dd className={detailValueClass}>{value || '—'}</dd>
    </div>)}
  </dl>;
}
